<a class="flex items-center" routerLink="cart">
    <button type="button" class="cart">
        <app-icon name="mdi:cart-outline" class="text-md text-gray-700 leading-4"></app-icon>
        <span @ShowHide *ngIf="cartProcessing$ | async" class="loader"></span>
    </button>

    <span class="text-xs leading-none font-semibold whitespace-nowrap">{{ cart$ | async | total | price }}</span>
</a>
